export const MODULE = 'TAX_CREDIT';
export const GET_TAX_CREDIT = `${MODULE}/get_tax_credit`;
export const SHOW_TAX_CREDIT = `${MODULE}/show_tax_credit`;
export const UPDATE_TAX_CREDIT = `${MODULE}/update_tax_credit`;
export const VALIDATE_TAX_CREDIT = `${MODULE}/validate_tax_credit`;
export const TRANSFER_TAX_CREDIT = `${MODULE}/transfer_tax_credit`;
export const CREATE_TAX_CREDIT = `${MODULE}/create_tax_credit`;
export const REMOVE_TAX_CREDIT = `${MODULE}/remove_tax_credit`;
export const GET_ADMIN_MODULE = 'ADMIN_MODULE/get_admin_module';
export const GET_TAX_CREDIT_TRANSACTIONS = `${MODULE}/get_tax_credit_transaction`;

export const GET_LIST_TAX_CREDIT = `${MODULE}/get_list_tax_credit`;

export const TRANSACTION_TYPE = [
  { label: 'CREDIT', value: 'CREDIT' },
  { label: 'REDUCE', value: 'REDUCE' },
];

export const FORM_DATA = {
  name: '',
};
